import { Alert } from "react-bootstrap";

/**
 * @param {Object} props 
 * @param {"info" | "error" | "success"} props.type
 * @param {boolean} props.noIcon
 * @param {string} props.className
 */
export default function AlertBox({ type, noIcon, className = "", children, ...rest }) {
    const types = {
        info: "bg-blue-200 border-blue-300 text-blue-900",
        error: "bg-red-200 border-red-300 text-red-900",
        success: "bg-green-200 border-green-300 text-green-900"
    };

    const icons = {
        info: "bi-info-circle",
        error: "bi-exclamation-circle",
        success: "bi-check-circle"
    };

    return (
        <Alert {...rest} className={`p-3 flex items-center justify-center gap-2 ${types[type]} ${className}`}>
            {!noIcon && <i className={`bi-icon ${icons[type]} text-xl`} />}
            <span>{children}</span>
        </Alert>
    );
}